import productAreas, * as fromProductAreas from './reducer';

export { default as types } from './types';
export { productAreasSelect } from './actions';
export { fromProductAreas, productAreas };
